// extracted by mini-css-extract-plugin
export default {"groupHeader":"LahDe","rootDark":"UpQRe","menuDark":"OlsDZ"};